import { c as _c } from "react/compiler-runtime";
import { createListCollection } from '@chakra-ui/react';
import { ComboboxContent, ComboboxControl, ComboboxEmpty, ComboboxInput, ComboboxItem, ComboboxItemGroup, ComboboxItemText, ComboboxRoot } from '@src/components/chakra-ui/combobox';
import { IANA_TIMEZONE_SET } from '@src/components/sco/Advisors/data/ianaTimezones2026c';
import { groupTimezoneOptions, matchesTimezoneQuery, timezoneLabel, timezoneOptions, type TimezoneOption } from '@src/components/sco/Advisors/utils/timezoneSelect';
import { useMemo, useState } from 'react';
type TimezoneSelectProps = {
  value: string;
  onChange: (timezone: string) => void;
};
const BASE_ITEMS = timezoneOptions();
const toCollection = (items: TimezoneOption[]) => createListCollection<TimezoneOption>({
  items,
  itemToString: item => item.label,
  itemToValue: item => item.value
});
export const TimezoneSelect = t0 => {
  const $ = _c(30);
  const {
    value,
    onChange
  } = t0;
  const extraUnknown = value && !IANA_TIMEZONE_SET.has(value) ? value : undefined;
  let t1;
  if ($[0] !== extraUnknown) {
    t1 = extraUnknown ? timezoneOptions(extraUnknown) : BASE_ITEMS;
    $[0] = extraUnknown;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = t1;
  const selectedLabel = value ? timezoneLabel(value) : "";
  const [query, setQuery] = useState("");
  let t2;
  if ($[2] !== query || $[3] !== selectedLabel) {
    t2 = !query.trim() || query === selectedLabel ? "" : query;
    $[2] = query;
    $[3] = selectedLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const filterQuery = t2;
  let t3;
  if ($[5] !== filterQuery || $[6] !== items) {
    let t4;
    if ($[8] !== filterQuery) {
      t4 = item => matchesTimezoneQuery(item.label, filterQuery);
      $[8] = filterQuery;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = items.filter(t4);
    $[5] = filterQuery;
    $[6] = items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const filteredItems = t3;
  let t4;
  if ($[10] !== filteredItems) {
    t4 = toCollection(filteredItems);
    $[10] = filteredItems;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const collection = t4;
  let t5;
  if ($[12] !== filteredItems) {
    t5 = groupTimezoneOptions(filteredItems);
    $[12] = filteredItems;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const groups = t5;
  let t6;
  if ($[14] !== value) {
    t6 = value ? [value] : [];
    $[14] = value;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== onChange) {
    t7 = details => {
      const next = details.value[0];
      if (next) {
        setQuery("");
        onChange(next);
      }
    };
    $[16] = onChange;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = event => {
      setQuery(event.currentTarget.value);
    };
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ComboboxControl><ComboboxInput placeholder={"Search timezones\u2026"} onChange={t8} onFocus={_temp} onInput={event_1 => {
        setQuery(event_1.currentTarget.value);
      }} /></ComboboxControl>;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ComboboxEmpty>No matching timezones</ComboboxEmpty>;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== groups) {
    t11 = groups.map(_temp3);
    $[21] = groups;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <ComboboxContent>{t10}{t11}</ComboboxContent>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== collection || $[26] !== t12 || $[27] !== t6 || $[28] !== t7) {
    t13 = <ComboboxRoot openOnClick={true} collection={collection} inputBehavior="autohighlight" maxW="md" value={t6} onValueChange={t7}>{t9}{t12}</ComboboxRoot>;
    $[25] = collection;
    $[26] = t12;
    $[27] = t6;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
function _temp(event_0) {
  event_0.currentTarget.select();
}
function _temp2(item_0) {
  return <ComboboxItem key={item_0.value} item={item_0}><ComboboxItemText>{item_0.label}</ComboboxItemText></ComboboxItem>;
}
function _temp3(group) {
  return <ComboboxItemGroup key={group.name} label={group.name}>{group.items.map(_temp2)}</ComboboxItemGroup>;
}